import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import LoginPage from './LoginPage';
import HostLogin from './HostLogin';
import MyPage from './MyPage.js';
import CorporateMypage from './CorporateMypage';
import api from './api.js';
import FormRequire from './FormRequire.js';
import Comp3Sub from './Comp3Sub.js';
import Comp4Sub from './Comp4Sub.js';
import FormElectricity from './FormElectricity.js';
import Comp7Sub from './Comp7Sub.js';
import Comp8Sub from './Comp8Sub.js';
import Comp9Sub from './Comp9Sub.js';
import Comp10Sub from './Comp10Sub.js';
import Comp11Sub from './Comp11Sub.js';
import Comp12Sub from './Comp12Sub.js';
import Comp13Sub from './Comp13Sub.js';
import CoExhibitMypage from './CoExhibitMypage.js';
import MypageInfo from './MypageInfo.js';
import MailFormPage from './MailForm.js';
import HostMypage from './HostMypage.js';
import CorporateMypageInfo from './CorporateMypageInfo.js';
import CorporateInfo from './CorporateInfo.js';
import ExhibitorInfo from './ExhibitorInfo.js';
import CreateMail from './CreateMail.js';
import CreateNotice from './CreateNotice.js';
import NoticeDetail from './NoticeDetail.js';
import FormHistoryTable from './FormHistory.js';
import ResetPassword from './ResetPassword.js';
import { NavigationHistoryProvider } from './common/navigationHistory.js';
import Comp10_2Sub from './Comp10_2Sub.js';
import Comp11_2Sub from './Comp11_2Sub.js';
import Comp5Sub from './Comp5Sub.js';
import Comp6Sub from './Comp6Sub.js';
import Comp16Sub from './Comp16Sub.js';
import Comp17Sub from './Comp17Sub.js';
import Comp18Sub from './Comp18Sub.js';
import NavigationTracker from './common/NavigationTracker.js';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [exhibitorId, setExhibitorId] = useState(null);
  const location = useLocation();

  useEffect(() => {
      const userData = localStorage.getItem("user");
      if (userData) {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);

        if (parsedUser?.exhibitor_id) {
    setExhibitorId(parsedUser.exhibitor_id);
  } else {
    console.warn("exhibitor_id が見つかりません");
  }}}, [location]);

  return (
    <NavigationHistoryProvider>
      <NavigationTracker />
      <Routes>
        <Route
          path="/"
          element={
            <LoginPage
              setIsAuthenticated={setIsAuthenticated}
              setUser={setUser}
            />
          }
        />
        <Route
          path="/login/host"
          element={<HostLogin setIsAuthenticated={setIsAuthenticated} />}
        />
        <Route path="/mypage/:exhibitorId" element={<MyPage />} />
        <Route path="/co-exhibit-mypage/:exhibitorId" element={<CoExhibitMypage />} />
        <Route path="/corporate-mypage/:representativeId" element={<CorporateMypage />} />
        <Route path="/form-require" element={<FormRequire exhibitorId={exhibitorId} />} />
        <Route path="/form-o-3" element={<Comp3Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-4" element={<Comp4Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-elec" element={<FormElectricity exhibitorId={exhibitorId} />} />
        <Route path="/form-o-5" element={<Comp5Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-6" element={<Comp6Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-7" element={<Comp7Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-8" element={<Comp8Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-9" element={<Comp9Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-10" element={<Comp10Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-10_2" element={<Comp10_2Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-11" element={<Comp11Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-11_2" element={<Comp11_2Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-12" element={<Comp12Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-13" element={<Comp13Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-16" element={<Comp16Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-o-17" element={<Comp17Sub exhibitorId={exhibitorId} />} />
        <Route path="/form-r-18" element={<Comp18Sub exhibitorId={exhibitorId} />} />
        <Route path="/mypage-info/:exhibitorId" element={<MypageInfo />} />
        <Route path="/mail-form/" element={<MailFormPage />} />
        <Route path="/host-dashboard/" element={<HostMypage />} />
        <Route path="/corporate-mypage-info/:representativeId" element={<CorporateMypageInfo />} />
        <Route path="/exhibitor-info" element={<ExhibitorInfo />} />
        <Route path="/corporate-info" element={<CorporateInfo />} />
        <Route path="/create-mail" element={<CreateMail />} />
        <Route path="/create-notice" element={<CreateNotice />} />
        <Route path="/news/:noticeId" element={<NoticeDetail />} />
        <Route path="/form-history" element={<FormHistoryTable />} />
        <Route path="/reset-password/:representative_id/:user_id" element={<ResetPassword />} />
      </Routes>
    </NavigationHistoryProvider>
  );
}

export default App;